import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import * as serviceWorker from './serviceWorker';
import 'react-toastify/dist/ReactToastify.css';

const isDeployedBcitHost = /\.bcit\.ca$/i.test(window.location.hostname);

// The /cancel page and its API call carry a booking token (holds the booker's email) in the query string
const stripQuery = (url?: string) => url?.split('?')[0];

if (process.env.NODE_ENV === 'production' && isDeployedBcitHost) {
    Sentry.init({
        dsn: 'https://0dbce85689144f3ab8b9d9a25cfd7e5d@o972955.ingest.sentry.io/6007926',
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 0.1,
        environment: window.location.host.includes('test') ? 'staging' : 'production',
        beforeSend(event) {
            if (event.user) {
                delete event.user.email;
                delete event.user.username;
            }
            if (event.request) {
                delete event.request.cookies;
            }
            return event;
        },
        beforeBreadcrumb(breadcrumb) {
            if (breadcrumb.category === 'console') return null;
            if (breadcrumb.data?.url?.includes('/Auth/AssertionConsumerService')) return null;
            if (breadcrumb.data?.url) breadcrumb.data.url = stripQuery(breadcrumb.data.url);
            if (breadcrumb.data?.from) breadcrumb.data.from = stripQuery(breadcrumb.data.from);
            if (breadcrumb.data?.to) breadcrumb.data.to = stripQuery(breadcrumb.data.to);
            return breadcrumb;
        },
    });

    // Runs on errors and transactions - beforeSend doesn't see transactions in this SDK version
    Sentry.addGlobalEventProcessor((event) => {
        if (event.request?.url) event.request.url = stripQuery(event.request.url);
        if (event.request?.headers?.Referer) event.request.headers.Referer = stripQuery(event.request.headers.Referer) as string;
        event.spans?.forEach((span) => {
            if (span.description) span.description = stripQuery(span.description);
            if (span.data?.url) span.data.url = stripQuery(span.data.url);
        });
        return event;
    });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
